"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TailSpin = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var TailSpin = function TailSpin(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("svg", {
      width: props.width,
      height: props.height,
      viewBox: "0 0 38 38",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": props.label
    },
    /*#__PURE__*/
    _react["default"].createElement("defs", null,
    /*#__PURE__*/
    _react["default"].createElement("linearGradient", {
      x1: "8.042%",
      y1: "0%",
      x2: "65.682%",
      y2: "23.865%",
      id: "a"
    },
    /*#__PURE__*/
    _react["default"].createElement("stop", {
      stopColor: props.color,
      stopOpacity: "0",
      offset: "0%"
    }),
    /*#__PURE__*/
    _react["default"].createElement("stop", {
      stopColor: props.color,
      stopOpacity: ".631",
      offset: "63.146%"
    }),
    /*#__PURE__*/
    _react["default"].createElement("stop", {
      stopColor: props.color,
      offset: "100%"
    }))),
    /*#__PURE__*/
    _react["default"].createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    },
    /*#__PURE__*/
    _react["default"].createElement("g", {
      transform: "translate(1 1)"
    },
    /*#__PURE__*/
    _react["default"].createElement("path", {
      d: "M36 18c0-9.94-8.06-18-18-18",
      id: "Oval-2",
      stroke: props.color,
      strokeWidth: "2"
    },
    /*#__PURE__*/
    _react["default"].createElement("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      from: "0 18 18",
      to: "360 18 18",
      dur: "0.9s",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      fill: "#fff",
      cx: "36",
      cy: "18",
      r: props.radius
    },
    /*#__PURE__*/
    _react["default"].createElement("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      from: "0 18 18",
      to: "360 18 18",
      dur: "0.9s",
      repeatCount: "indefinite"
    })))))
  );
};

exports.TailSpin = TailSpin;
TailSpin.propTypes = {
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  color: _propTypes["default"].string,
  label: _propTypes["default"].string,
  radius: _propTypes["default"].number
};
TailSpin.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  radius: 1,
  label: "audio-loading"
};